<template>
  <RadioGroup>
    <Radio
      id="viewer"
      name="authority"
      :value="false"
      variant="authority"
      :checked="checked"
      :disabled="disabled"
      @change="change"
    >
      <p class="c-radio__text">
        サイト限定ユーザー
        <Tooltip>
          アクセス権のあるサイトのみ操作できます
        </Tooltip>
      </p>
    </Radio>
    <Radio
      id="manager"
      name="authority"
      :value="true"
      variant="authority"
      :checked="checked"
      :disabled="disabled"
      @change="change"
    >
      <p class="c-radio__text">
        アカウント管理ユーザー
        <Tooltip>
          全サイトを操作できます<br />
          ユーザーの追加・削除ができます<br />
          ユーザーの権限を変更できます<br />
          サイトの追加・削除ができます
        </Tooltip>
      </p>
    </Radio>
  </RadioGroup>
</template>

<script>
import Tooltip from '@/components/Tooltip';
import Radio from '@/components/Radio';
import RadioGroup from '@/components/RadioGroup';

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Tooltip,
    Radio,
    RadioGroup
  },
  methods: {
    change(checked) {
      this.$emit('change', checked);
    }
  }
};
</script>
